import type { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';
import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { Button } from '@gik/ui-legacy/Button';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { UserPagesList } from './UserPagesList';
import { translationKeys } from './i18n/en';

export interface IUserPagesSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  items?: InkindPageAPIModel[];
}

const blockName = 'user-pages-section';

export function UserPagesSectionComp({ ...otherProps }: IUserPagesSectionProps) {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  return (
    <div className={bem()} {...otherProps}>
      <section className={bem('header', null, 'justify-between md:justify-start')}>
        <div className={bem('header-text')}>{t(translationKeys.title)}</div>
        <Button
          type="a"
          href="/create"
          variant="secondary"
          className={bem('create-btn')}
          style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
        >
          {t(translationKeys.btnCreateNewPage)}
        </Button>
      </section>
      <section className={bem('about')}>
        <p className={bem('about-text')}>
          These are the Pages you’ve created, organize, or have chosen to follow. Pages you organize have an{' '}
          <strong style={{ color: 'orange' }}>orange</strong> border
        </p>
      </section>

      <UserPagesList />
    </div>
  );
}

export const UserPagesSection = withComponentErrorBoundary(UserPagesSectionComp);
